// **axios封装**
// 请求拦截、响应拦截、错误统一处理
import base from './base.js'; // 导入接口域名列表
import axios from 'axios';
import md5 from "../assets/js/md5"
import router from '../router';
import {Message} from 'element-ui';

// 退出登陆
const loginOut = () => {
    if ((router.history.current.path !== "/real-market" && router.history.current.path !== "/index") && !navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        if (router.history.current.path === "/member" && router.history.current.query.code) {
            router.replace({path: '/real-market?path=member&parameter='+router.history.current.query.code});
        } else {
            router.replace({path: '/real-market'});
        }
    }
}
// 请求失败后的错误统一处理
// @param {Number} status 请求失败的状态码
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 账号密码错误（不确定）
        case 400:
            if (other.non_field_errors && other.non_field_errors[0]) {
                Message.error(other.non_field_errors[0]);
            } else {
                Message.error('您的账号密码错误');
            }
            break;
        // 401: 未登录状态，跳转到广场页
        case 401:
            window.localStorage.setItem("token", '')
            window.localStorage.removeItem("token");
            window.changeLogin();
            loginOut();
            break;
        // 403 token过期
        // 清除token并跳转登录页
        case 403:
            Message.error('登录过期，请重新登录');
            window.localStorage.setItem("token", '')
            window.localStorage.removeItem("token");
            window.changeLogin();
            loginOut();
            // store.commit('loginSuccess', null);
            break;
        // 404请求不存在
        case 404:
            Message.error('请求的资源不存在');
            break;
        default:
            Message.error('数据开小差，请稍后再试');
    }
}

// 跨域访问需要发送cookie
// axios.defaults.withCredentials = true

// 创建axios实例
let instance = axios.create({
    // 超时时间 单位是ms，这里设置了3s的超时时间
    timeout: 3 * 60 * 1000
});

// 请求拦截器
// 每次请求前，如果存在token则在请求头中携带token
instance.interceptors.request.use(config => {
    // console.log(config)
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    // config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
    config.header = {
        Authorization: "",
        "Content-Type": "application/json; charset=UTF-8", //配置请求头
        Connection: "keep-alive",
        // changeOrigin: true,
    };
    //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
    let token = (localStorage.getItem("token") === undefined || localStorage.getItem("token") === 'undefined') ? '' : localStorage.getItem("token"); // 获取token//这里取token之前，你肯定需要先拿到token,存一下
    let time = new Date().getTime();
    // 服务器校验
    if (config.url.indexOf("?") > -1) {
        config.url =
            config.url +
            `&sign=${md5("YDDCASxDeToM2KL5qRaN2a" + time)}&time=${time}`;
    } else {
        config.url =
            config.url +
            `?sign=${md5("YDDCASxDeToM2KL5qRaN2a" + time)}&time=${time}`;
    }
    if (token) {
        config.headers["Authorization"] = "JWT " + token;
    }
    return config;
},
error => Promise.error(error))

// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    res => {
        if (res.status === 200 || res.status === 201) {
            if (res.data.code === 200) {
                return Promise.resolve(res.data)
            } else {
                let url = res.config.url.split("?sign")[0].split(base.bds)[1];
                // 如果是登陆接口则返回正常
                if (url === '/user/users/') {
                    return Promise.resolve(res.data)
                } else {
                    if (Array.isArray(res.data)) {
                        return Promise.resolve(res.data[0])
                    } else {
                        Message.error(res.data.message);
                        return Promise.reject(res.data)
                    }
                }
            }
        } else {
            return Promise.reject(res.data)
        }
    },
    // 请求失败
    error => {
        const {response} = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围
            errorHandle(response.status, response.data);
            return Promise.reject(response);
        } else {
            // 处理断网的情况
            // eg:请求超时或断网时，更新state的network状态
            // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
            if (!window.navigator.onLine) {
                // store.commit('changeNetwork', false);
            } else {
                return Promise.reject(error);
            }
        }
    });

export default instance;



// WEBPACK FOOTER //
// ./src/utils/http.js